import { createAction, props } from '@ngrx/store';

export const setNotesAccordionOpenState = createAction(
    '[UI] Set Notes Accordion Open State',
    props<{ locationId: string; accordionName: string; isOpen: boolean }>(),
);
